import { render, staticRenderFns } from "./ImportantMessageV2026.vue?vue&type=template&id=20aaabda&scoped=true"
import script from "./ImportantMessageV2026.vue?vue&type=script&lang=js"
export * from "./ImportantMessageV2026.vue?vue&type=script&lang=js"
import style0 from "./ImportantMessageV2026.vue?vue&type=style&index=0&id=20aaabda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aaabda",
  null
  
)

export default component.exports